import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapBreadcrumbs } from '../../mappers';
import { IBreadcrumb } from '../../types/breadcrumb';

import { TReduxActions } from '../../types/redux';

const defaultState: IBreadcrumb[] = [];

export function breadcrumbsReducer(state = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapBreadcrumbs(action.payload);
  }

  return state;
}
